module.exports = __webpack_public_path__ + "img/email.f5fbc44b.png";